var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "client-list grid grid__base" }, [
    _c("div", { staticClass: "client-list--container grid--container" }, [
      _c("div", { staticClass: "client-list--row grid--row" }, [
        _c("div", { staticClass: "grid--col client-list--title-col" }, [
          _c("h3", { staticClass: "client-list--title" }, [
            _vm._v(_vm._s(_vm.title))
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "grid--col client-list--filter-col" },
          [
            _c("multiselect", {
              staticClass: "client-list--filter",
              attrs: {
                placeholder: _vm.filterPlaceholder,
                options: _vm.selectOptions
              },
              scopedSlots: _vm._u([
                {
                  key: "singleLabel",
                  fn: function(props) {
                    return [
                      _vm._v(
                        "\n                        " +
                          _vm._s(props.option.label) +
                          "\n                    "
                      )
                    ]
                  }
                },
                {
                  key: "option",
                  fn: function(props) {
                    return [_c("span", [_vm._v(_vm._s(props.option.label))])]
                  }
                }
              ]),
              model: {
                value: _vm.selectedFilter,
                callback: function($$v) {
                  _vm.selectedFilter = $$v
                },
                expression: "selectedFilter"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid--row client-list--list" },
        _vm._l(_vm.filteredListItems, function(item, key) {
          return _c(
            "client-logo",
            _vm._b(
              { key: key, staticClass: "grid--col client-list--item" },
              "client-logo",
              item,
              false
            )
          )
        }),
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b36d23d", { render: render, staticRenderFns: staticRenderFns })
  }
}